export default __webpack_public_path__ + "static/media/eu-logo-en.2ea13929.png";